<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <page-header title="Bodegas"></page-header>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="bodegas"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              field="id"
              label="Código"
              width="5%"
              class="has-text-centered"
            >
              <span>
                {{ props.row.id }}
              </span>
            </b-table-column>
            <b-table-column v-slot="props" field="nombre" label="Nombre Bodega">
              <span>
                {{ props.row.nombre }}
              </span>
            </b-table-column>
            <b-table-column
              field="codigo"
              label="Código SAP"
              width="6%"
              class="has-text-centered"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica el código de almacén correspondiente en SAP."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <span>
                  {{ props.row.codigo }}
                </span>
              </template>
            </b-table-column>
            <b-table-column
              field="estaActivo"
              label="Está activo?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén está activo."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="props.row.estaActivo ? 'check' : 'times'" />
              </template>
            </b-table-column>
            <b-table-column
              field="puedeReimprimir"
              label="Puede Reimprimir?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén permite reimprimir los picking list ya impresos automáticamente."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon :icon="props.row.puedeReimprimir ? 'check' : 'times'" />
              </template>
            </b-table-column>
            <b-table-column
              field="puedePickearVendedor"
              label="Vendedor puede pickear?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén permite que el vendedor que emite el pedido pueda pickear."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon
                  :icon="props.row.puedePickearVendedor ? 'check' : 'times'"
                />
              </template>
            </b-table-column>
            <b-table-column
              field="separaPedidosPorZona"
              label="Separa pedidos por zona?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén permite que los pedidos se separen por zonas."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon
                  :icon="props.row.separaPedidosPorZona ? 'check' : 'times'"
                />
              </template>
            </b-table-column>
            <b-table-column
              field="obligaPickingCodigoBarra"
              label="Obliga picking por códigos de barra?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén obliga a pickear con códigos de barra (Advertencia TC-26)."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon
                  :icon="props.row.obligaPickingCodigoBarra ? 'check' : 'times'"
                />
              </template>
            </b-table-column>
            <b-table-column
              field="ordenaPickingUbicacion"
              label="Ordena items por ubicación?"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén ordena los items del picking por orden de ubicaciones en PBE."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon
                  :icon="props.row.ordenaPickingUbicacion ? 'check' : 'times'"
                />
              </template>
            </b-table-column>
            <b-table-column
              field="facturarDesdeMopi"
              label="Facturar en SAP"
              width="9%"
              :centered="true"
            >
              <template v-slot:header="{ column }">
                <b-tooltip
                  label="Indica si el almacén factura directamente desde MOPI."
                  append-to-body
                  dashed
                >
                  {{ column.label }}
                </b-tooltip>
              </template>
              <template v-slot="props">
                <b-icon
                  :icon="props.row.facturarDesdeMopi ? 'check' : 'times'"
                />
              </template>
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="8%">
              <div class="buttons has-text-centered">
                <b-button
                  type="is-info"
                  size="is-small"
                  title="Modificar"
                  class="mr-1"
                  @click="modificarRegistro(props.row.id)"
                >
                  <b-icon icon="pencil-alt" />
                </b-button>
                <div v-if="props.row.estaActivo">
                  <b-button
                    type="is-success"
                    size="is-small"
                    title="Zonas"
                    class="mr-1"
                    @click="goForwardHandle(props.row.id)"
                  >
                    <b-icon icon="map" pack="far" />
                  </b-button>
                  <b-button
                    type="is-success"
                    size="is-small"
                    title="Tipos de Entrega"
                    @click="goForwardTiposEntregaHandle(props.row.id)"
                  >
                    <b-icon icon="box" />
                  </b-button>
                </div>
              </div>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            icon-left="plus"
            :disabled="!puedeAgregar"
            @click="agregarRegistro"
          >
            Agregar
          </b-button>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="estaModalAbierto"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
      @close="cerrarModalHandle"
    >
      <bodega-form
        :modificacion="modificacion"
        :objeto="objeto"
        :sucursal="`${sucursal.id}`"
        :titulo="tituloForm"
        @close="cerrarModalHandle"
      />
    </b-modal>
  </div>
</template>

<script>
import qs from 'qs'
import { mapGetters } from 'vuex'

import BodegaForm from '@/components/mantenedor/bodegas/BodegaForm.vue'
import PageHeader from '@/components/shared/PageHeader.vue'
import { bodegaService } from '@/services'

export default {
  name: 'Bodegas',
  components: {
    BodegaForm,
    PageHeader
  },
  data() {
    return {
      bodegas: [],
      estaModalAbierto: false,
      paginaActual: 1,
      tamanoPagina: 10,
      tituloForm: null,
      objeto: null,
      modificacion: false
    }
  },
  computed: {
    ...mapGetters('sesion', ['bodega']),
    sucursal() {
      return this.bodega.sucursal
    },
    puedeAgregar() {
      return this.sucursal
    }
  },
  mounted() {
    this.getBodegas()
  },
  methods: {
    agregarRegistro() {
      this.tituloForm = 'Agregar Bodega'
      this.estaModalAbierto = true
    },
    modificarRegistro(id) {
      this.tituloForm = 'Modificar Bodega'
      this.objeto = this.bodegas.filter((item) => item.id === id)[0]
      this.modificacion = true
      this.estaModalAbierto = true
    },
    confirmarEliminarRegistro(id) {
      const objeto = this.bodegas.filter((item) => item.id === id)[0]
      this.$buefy.dialog.confirm({
        title: 'Quitar bodega',
        message: `¿Est&aacute; seguro de <b>quitar</b> la bodega <b>${objeto.nombre}</b>?`,
        confirmText: 'Eliminar',
        cancelText: 'Cancelar',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.eliminarRegistro(id)
      })
    },
    eliminarRegistro(id) {
      bodegaService
        .deleteBodega(id)
        .then(() => {
          this.notificarAccionCompletada('Se eliminó bodega correctamente')
          this.getBodegas()
        })
        .catch((error) => this.procesarError(error))
    },
    cerrarModalHandle(payload = false) {
      this.estaModalAbierto = false
      this.tituloForm = ''
      this.objeto = null
      this.modificacion = false
      if (payload) {
        this.getBodegas()
      }
    },
    getBodegas() {
      const self = this
      return bodegaService
        .getBodegas(this.sucursal.id)
        .then((response) => (self.bodegas = response.data))
        .catch((error) => this.procesarError(error))
    },
    goForwardHandle(id) {
      const queryUrl = qs.stringify({
        sucursalId: this.sucursal.id,
        bodegaId: id
      })
      this.$router.push(`/mantenedor/zonas?${queryUrl}`)
    },
    goForwardTiposEntregaHandle(_) {
      this.$router.push(`/mantenedor/tipos-entrega`)
    }
  }
}
</script>
